import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store"

Vue.use(VueRouter)

let questionsRoutes = [
  {
    path:"add",
    name:"addQuestion",
    component: () => import(/* webpackChunkName: "addQuestion" */ '../components/Questions/AddQuestion.vue'),
  },
  {
    path:"my",
    name:"myQuestions",
    component: () => import(/* webpackChunkName: "myQuestions" */ '../components/Questions/MyQuestions.vue'),
  },
  {
    path:"all",
    name:"allQuestions",
    component: () => import(/* webpackChunkName: "allQuestions" */ '../components/Questions/AllQuestions.vue'),
  },
]

let conversationsRoutes = [
  {
    path:"add/:questionID?",
    name:"addConversation",
    component: () => import(/* webpackChunkName: "addConversation" */ '../components/Conversations/AddConversation.vue'),
  },
  {
    path:"my",
    name:"myConversations",
    component: () => import(/* webpackChunkName: "myConversations" */ '../components/Conversations/MyConversations.vue'),
  },
]



const routes = [
  {
    path: '/',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta:{
      mustBeLoggedIn: true
    }
  },
  {
    path: '/setup',
    name: 'setup',
    component: () => import(/* webpackChunkName: "setup" */ '../views/Setup.vue'),
    meta:{
      mustBeLoggedIn: true
    }
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import(/* webpackChunkName: "contact" */ '../views/app/ContactsPage.vue'),
    meta:{
      mustBeLoggedIn: true
    }
  },
  {
    path: '/conversations',
    name: 'conversations',
    component: () => import(/* webpackChunkName: "conversations" */ '../views/app/Conversations.vue'),
    meta:{
      mustBeLoggedIn: true
    },
    children:conversationsRoutes
  },
  {
    path: '/conversationchat/:conversationId',
    name: 'conversationchat',
    component: () => import(/* webpackChunkName: "conversationChat" */ '../views/app/ConversationChat.vue'),
    meta:{
      mustBeLoggedIn: true
    }
  },
  {
    path: '/questions',
    name: 'questions',
    component: () => import(/* webpackChunkName: "questions" */ '../views/app/QuestionsPage.vue'),
    meta:{
      mustBeLoggedIn: true
    },
    children:questionsRoutes
  },
  {
    path: "/login",
    name: "login",
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: "/license",
    name: "license",
    component: () => import(/* webpackChunkName: "legal" */ '../views/License.vue')
  },
  {
    path: "/termsofuse",
    name: "termsofuse",
    component: () => import(/* webpackChunkName: "tos" */ '../views/Termsofuse.vue')
  }
]



const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  //console.log(to);
  if (to.meta.mustBeLoggedIn && !store.state.auth.user)
    return next({ name: 'login' })
  else
    return next()
})

export default router
